import { AlertCircle, Sparkles, Clock, Target, Zap, CheckCircle, Lightbulb, Coffee } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const ProblemSolutionSection = () => {
  const { t } = useTranslation();

  return (
    <div className="max-w-6xl mx-auto mb-16 px-4">
      <div className="text-center mb-8">
        <h2 className="text-3xl md:text-4xl font-bold mb-3 bg-gradient-to-r from-foreground to-newsletter-primary bg-clip-text text-transparent">
          {t('problemSolution.title')}
        </h2>
        <p className="text-muted-foreground text-lg">
          {t('problemSolution.subtitle')}
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        {/* Problem Column */}
        <div className="relative p-6 md:p-8 rounded-2xl bg-destructive/5 border-2 border-destructive/20 backdrop-blur-sm">
          <div className="absolute -top-4 left-6 px-4 py-1.5 bg-destructive/90 rounded-full">
            <span className="text-xs font-bold text-white uppercase tracking-wide">
              {t('problemSolution.problem.badge')}
            </span>
          </div>
          
          <div className="mt-4">
            <div className="flex items-center gap-3 mb-6">
              <AlertCircle className="w-8 h-8 text-destructive flex-shrink-0" />
              <h3 className="text-xl font-bold text-foreground">
                {t('problemSolution.problem.title')}
              </h3>
            </div>

            <ul className="space-y-4">
              {[1, 2, 3, 4, 5].map((i) => (
                <li key={i} className="flex items-start gap-3 text-muted-foreground">
                  <AlertCircle className="w-5 h-5 text-destructive flex-shrink-0 mt-0.5" />
                  <span>{t(`problemSolution.problem.point${i}`)}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Solution Column */}
        <div className="relative p-6 md:p-8 rounded-2xl bg-newsletter-primary/5 border-2 border-newsletter-primary/30 backdrop-blur-sm">
          <div className="absolute -top-4 left-6 px-4 py-1.5 border-2 border-newsletter-primary rounded-full bg-background">
            <span className="text-xs font-bold text-white uppercase tracking-wide">
              {t('problemSolution.solution.badge')}
            </span>
          </div>
          
          <div className="mt-4">
            <div className="flex items-center gap-3 mb-6">
              <Sparkles className="w-8 h-8 text-newsletter-accent flex-shrink-0" />
              <h3 className="text-xl font-bold text-foreground">
                {t('problemSolution.solution.title')}
              </h3>
            </div>

            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-muted-foreground">
                <CheckCircle className="w-5 h-5 text-newsletter-accent flex-shrink-0 mt-0.5" />
                <span>{t('problemSolution.solution.point1')}</span>
              </li>
              <li className="flex items-start gap-3 text-muted-foreground">
                <Target className="w-5 h-5 text-newsletter-accent flex-shrink-0 mt-0.5" />
                <span>{t('problemSolution.solution.point2')}</span>
              </li>
              <li className="flex items-start gap-3 text-muted-foreground">
                <Clock className="w-5 h-5 text-newsletter-accent flex-shrink-0 mt-0.5" />
                <span>{t('problemSolution.solution.point3')}</span>
              </li>
              <li className="flex items-start gap-3 text-muted-foreground">
                <Zap className="w-5 h-5 text-newsletter-accent flex-shrink-0 mt-0.5" />
                <span>{t('problemSolution.solution.point4')}</span>
              </li>
              <li className="flex items-start gap-3 text-muted-foreground">
                <Coffee className="w-5 h-5 text-newsletter-accent flex-shrink-0 mt-0.5" />
                <span>{t('problemSolution.solution.point5')}</span>
              </li>
              <li className="flex items-start gap-3 text-muted-foreground">
                <Lightbulb className="w-5 h-5 text-newsletter-accent flex-shrink-0 mt-0.5" />
                <span>{t('problemSolution.solution.point6')}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
